import React, { useEffect, useRef } from 'react';
import { Eraser } from 'lucide-react';

export const SignaturePad = ({ onChange }) => {
  const ref = useRef(null);
  const drawing = useRef(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#0b2545';
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext('2d');
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL('image/png'));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    onChange('');
  };

  return (
    <div className="relative">
      <canvas
        ref={ref}
        data-testid="baa-signature-pad"
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
        onPointerLeave={up}
        className="w-full h-32 rounded-lg border-2 border-dashed border-slate-300 bg-white touch-none cursor-crosshair"
      />
      <span className="absolute left-3 bottom-2 text-[11px] text-slate-400 pointer-events-none">Sign above with your mouse or finger</span>
      <button type="button" onClick={clear} data-testid="baa-signature-clear"
        className="absolute right-2 top-2 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-800 bg-white/90 px-2 py-1 rounded-md border">
        <Eraser className="w-3 h-3" /> Clear
      </button>
    </div>
  );
};
